<div class="row">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
      <form [formGroup]="deviceForm" novalidate>
          <table class="table table-condensed" *ngIf="!sppModel && !isSwissdamedIvddRegulation()">
              <tbody>
                  <tr>
                      <td class="col-sm-3 no-left-padding" *ngIf="applicableRegulation != 'IVDR'">
                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>Reusable Surgical Instrument?</th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="reusableSurgical"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>
                      <td class="col-sm-3" *ngIf="applicableRegulation != 'IVDR'">
                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>Measuring Function?</th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="measuringFunction"></label>
                                      </td>

                                  </tr>
                              </tbody>
                          </table>
                      </td>
                      <td class="col-sm-3" *ngIf="applicableRegulation != 'IVDR'">
                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>Active Device?</th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="activePowered"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>
                      <td class="col-sm-3 no-right-padding" *ngIf="applicableRegulation != 'IVDR'">
                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>Administer or Remove a Medicinal Substance?</th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="administeringMedicine"></label>
                                      </td>

                                  </tr>
                              </tbody>
                          </table>
                      </td>
                  </tr>
              </tbody>
          </table>
          <table class="table table-condensed" *ngIf="!sppModel && !isSwissdamedIvddRegulation()">
              <tbody>
                  <tr>
                      <td class="col-sm-3 no-left-padding" *ngIf="applicableRegulation != 'IVDR'">

                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>Implantable?</th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="implantable"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>
                      <td class="col-sm-9 no-right-padding" *ngIf="applicableRegulation != 'IVDR' && !hideSwissdamedMddAimddFields()">
                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>
                                          For Risk Class IIb implantable: Sutures, Staples, Dental Fillings,
                                          Dental Braces, Tooth Crowns, Screws, Wedges, Pins, Clips, and
                                          Connectors?
                                      </th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="forRiskClassImplantable"></label>
                                      </td>

                                  </tr>
                              </tbody>
                          </table>
                      </td>
                  </tr>
              </tbody>
          </table>
          <table class="table table-condensed" *ngIf=!sppModel>
              <tbody>
                  <tr>
                      <td class="col-sm-4 no-left-padding">

                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>Presence of Human Tissues, Cells, or Derivatives?</th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="containingHumanTissues"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>

                      <td class="col-sm-4">

                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>Presence of Animal Tissues, Cells, or Derivatives?</th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="containingAnimalTissues"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>

                      </td>

                      <td class="col-sm-4 no-right-padding" *ngIf="applicableRegulation != 'IVDR' && !isSwissdamedIvddRegulation()">
                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>Presence of a Medicinal Product Substance?</th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="containsMedicinalProductSubstance"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>

                  </tr>
              </tbody>
          </table>
          <table class="table table-condensed table-striped" *ngIf="!sppModel && applicableRegulation != 'IVDR' && !isSwissdamedIvddRegulation()">
              <tbody>
                  <tr>
                      <td class="col-sm-4 no-left-padding no-right-padding">
                          <table class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>
                                          Presence of a Medicinal Product Substance Derived from Human Blood or
                                          Plasma?
                                      </th>
                                  </tr>
                                  <tr>
                                      <td>
                                          <label controlName="containsBloodOrPlasmaSubstance"></label>
                                      </td>

                                  </tr>
                              </tbody>
                          </table>

                      </td>
                  </tr>

              </tbody>
          </table>

          <table class="table table-condensed table-striped" *ngIf="sppModel">
            <tbody>
                <tr>
                    <td class="col-sm-12 no-left-padding no-right-padding">

                        <table formArrayName="medPurposeForm" class="table table-inner table-condensed table-striped">
                            <tbody>
                                <tr>
                                    <th class="col-sm-8 right-padding-20">Medical Purpose of System or Procedure Pack?</th>
                                    <th class="col-sm-4">Language</th>
                                </tr>
                                <ng-container *ngIf="medPurposeForm.controls.length; else emptyTemplate2fields">
                                <tr formGroupName="{{i}}"
                                    *ngFor="let med of medPurposeForm.controls; let i = index">
                                    <td>
                                        <label controlName="value"></label>
                                    </td>
                                    <td>
                                        <label controlName="language"></label>
                                    </td>
                                </tr>
                                </ng-container>
                            </tbody>
                        </table>

                    </td>
                </tr>
            </tbody>
        </table>

        <table class="table table-condensed" *ngIf="!sppModel && applicableRegulation != 'MDR' && !hideSwissdamedMddAimddFields()">
            <tbody>
                <tr>
                    <td class="col-sm-4 no-left-padding">
                        <table class="table table-inner table-condensed table-striped">
                            <tbody>
                                <tr>
                                    <th>
                                        Presence of cells or substances of microbial origin?
                                    </th>
                                </tr>
                                <tr>
                                    <td>
                                        <label controlName="containsMicrobialSubstances"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="col-sm-4">
                        <table class="table table-inner table-condensed table-striped">
                            <tbody>
                                <tr>
                                    <th>
                                        Companion Diagnostic?
                                    </th>
                                </tr>
                                <tr>
                                    <td>
                                        <label controlName="companionDiagnostic"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="col-sm-4 no-right-padding">
                        <table class="table table-inner table-condensed table-striped">
                            <tbody>
                                <tr>
                                    <th>
                                        Reagent?
                                    </th>
                                </tr>
                                <tr>
                                    <td>
                                        <label controlName="reagent"></label>
                                    </td>

                                </tr>
                            </tbody>
                        </table>

                    </td>
                </tr>

            </tbody>
        </table>

        <table class="table table-condensed" *ngIf="!sppModel && applicableRegulation != 'MDR' && !hideSwissdamedMddAimddFields()">
            <tbody>
                <tr>
                    <td class="col-sm-2 no-left-padding">
                        <table class="table table-inner table-condensed table-striped">
                            <tbody>
                                <tr>
                                    <th>
                                        Near Patient Testing?
                                    </th>
                                </tr>
                                <tr>
                                    <td>
                                        <label controlName="nearPatientTesting"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="col-sm-2">
                        <table class="table table-inner table-condensed table-striped">
                            <tbody>
                                <tr>
                                    <th>
                                        Patient Self Testing?
                                    </th>
                                </tr>
                                <tr>
                                    <td>
                                        <label controlName="patientSelfTesting"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="col-sm-2">
                        <table class="table table-inner table-condensed table-striped">
                            <tbody>
                                <tr>
                                    <th>
                                        Professional Testing?
                                    </th>
                                </tr>
                                <tr>
                                    <td>
                                        <label controlName="professionalTesting"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="col-sm-2 no-right-padding">
                        <table class="table table-inner table-condensed table-striped">
                            <tbody>
                                <tr>
                                    <th>
                                        Instrument?
                                    </th>
                                </tr>
                                <tr>
                                    <td>
                                        <label controlName="instrument"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="col-sm-2 no-right-padding">
                        <table class="table table-inner table-condensed table-striped">
                            <tbody>
                                <tr>
                                    <th>
                                        IVD Kit?
                                    </th>
                                </tr>
                                <tr>
                                    <td>
                                        <label controlName="ivdKit"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

            </tbody>
        </table>
      </form>
  </div>
</div>
<ng-template #emptyTemplate2fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
